export default __webpack_public_path__ + "static/media/TransportoPaslaugos.12870d57.svg";